module.exports = __webpack_public_path__ + "static/media/register.263c0d26.jpg";